<template>
    <div class="form">
    <a-card title="新建项目">
        <v-gobackbutton slot="extra" >返回</v-gobackbutton>
            <a-form-model :model="record" ref="ruleForm" :rules="rules" :layout="formItemLayout"  :label-col="labelCol" :wrapper-col="wrapperCol">
                <a-form-model-item ref="projectname" label="项目名称" prop="projectname">
                    <a-input
                        v-model="record.projectname"
                        :addon-after="projectNameExtra"
                        @blur="
                            () => {
                                $refs.projectname.onFieldBlur();
                            }
                            "
                    />
                </a-form-model-item>

                <a-form-model-item ref="description" label="备注" prop="description">
                    <a-input
                        type="textarea"
                        style="height:200px"
                        v-model="record.description"
                        @blur="
                            () => {
                                $refs.description.onFieldBlur();
                            }
                            "
                    />
                </a-form-model-item>

                <a-form-model-item  :wrapper-col="{ span: 14, offset: 14 }" >
                    <a-button type="primary" @click="handleOk">
                        创建
                    </a-button>
                    <a-button style="margin-left: 10px;" @click="handleCancel">
                        取消
                    </a-button>
                </a-form-model-item>
            </a-form-model>

    </a-card>
    </div>
  
</template>
<script>
const projectNameExtra = "-zl-device"
export default {
    data() {
        return {
            labelCol: { span: 4 },
            wrapperCol: { span: 14 },
            projectNameExtra,
            record:{
                projectname:'',
                description:''
            },
            rules: {
                projectname: [
                    { required: true, message: '请输入系统名称', trigger: 'blur' },
                    { min: 1, max: 50, message: '请输入1~50个字符', trigger: 'blur' },
                ],
                description: [
                    { min: 1, max: 100, message: '请输入1~100个字符', trigger: 'blur' },
                ],

            },
            confirmLoading: false,
            formItemLayout:'horizontal'
        };
    },
  
    methods: {
        handleOk() {
            this.$refs.ruleForm.validate(valid => {
                if (valid) {
                    let params = {};
                    params.projectname = this.record.projectname + this.projectNameExtra;
                    params.description = this.record.description;
                    params.uraparams = false;
                    // //新增
                    this.$store
                        .dispatch({
                            type: "logservice/addlogproject",
                            params: params
                        })
                        .then((response) => {
                            console.log(response)
                            if(response.status == 200 && response.data.success == 1){
                                this.message.success("创建成功，一分钟内生效，请稍等刷新！");
                                this.handleCancel();
                            }
                        
                        });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },

        handleCancel() {
            this.resetForm();
            this.$router.back(-1);
        },
        resetForm() {
            this.$refs.ruleForm.resetFields();
        },
    },

    mounted(){
        
        
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
